export enum ESportType {
  /** 空 */
  Sport0 = 0,
  /** Soccer足球 */
  Sport1 = 1,
  /** IceHockey冰球 */
  Sport2 = 2,
  /** Basketball篮球 */
  Sport3 = 3,
  /** Rugby橄榄球 */
  Sport4 = 4,
  /** Tennis网球 */
  Sport5 = 5,
  /** American Football美国足球 */
  Sport6 = 6,
  /** Baseball棒球 */
  Sport7 = 7,
  /** Handball手球 */
  Sport8 = 8,
  /** Floorball地板球 */
  Sport10 = 10,
  /** Golf高尔夫球 */
  Sport12 = 12,
  /** Volleyball排球 */
  Sport13 = 13,
  /** Cricket玩板球 */
  Sport14 = 14,
  /** TableTennis乒乓球 */
  Sport15 = 15,
  /** Snooker斯诺克台球 */
  Sport16 = 16,
  /** Futsal五人制足球 */
  Sport17 = 17,
  /** MixedMartialArts综合格斗 */
  Sport18 = 18,
  /** Boxing拳击 */
  Sport19 = 19,
  /** Darts飞镖 */
  Sport20 = 20,
  /** Bowls草地滚球 */
  Sport21 = 21,
  /** WaterPolo水球 */
  Sport24 = 24,
  /** Cycling自行车 */
  Sport25 = 25,
  /** Badminton羽毛球 */
  Sport47 = 47,
  /** BeachVolleyball沙滩排球 */
  Sport51 = 51,
  /** F1赛车 */
  Sport92 = 92,
  /** Specials特殊投注 */
  Sport93 = 93,
  /** Stock Car Racing 赛车 */
  Sport94 = 94,
  /** 摩托车赛 （支持玩法：冠军） */
  Sport95 = 95,
  /** 奥林匹克 */
  Sport100 = 100,
  /** 亚运会 （支持玩法：冠军） */
  Sport101 = 101, //
  /** Dota2刀塔2 */
  Sport164 = 164,
  /** 无畏契约 */
  Sport169 = 169,
  /** LOL英雄联盟 */
  Sport165 = 165,
  /** E-Football电子足球 */
  Sport177 = 177,
  /** E-Basketball电子篮球 */
  Sport178 = 178,
  /** CS:GO反恐精英 */
  Sport179 = 179,
  /** KOG王者荣耀 */
  Sport180 = 180,
  /** 虚拟足球 （支持玩法：普通） */
  Sport1001 = 1001,
  /** 虚拟赛马 （支持玩法：普通） */
  Sport1020 = 1020,
  /** 虚拟赛狗 （支持玩法：普通） */
  Sport1021 = 1021,
  /** 虚拟沙地摩托车 （支持玩法：普通） */
  Sport1022 = 1022,
  /** 虚拟摩托车 （支持玩法：普通） */
  Sport1023 = 1023,
}

/** 赔率类型 */
export enum EOtp {
  /** 欧盘 */
  EUROPE = 1,
  /** 香港盘 */
  HONGKONG = 2,
  /** 马来盘 */
  MALAY = 3,
  /** 印尼盘 */
  INDONESIA = 4,
  /** 美盘 */
  AMERICAN = 5,
}

export enum EMatchType {
  /** 冠军 */
  Outright = 1,
  /** 常规体育 */
  Match = 2,
  /** 电竞 */
  Esport = 3,
  /** 虚拟体育 */
  Virtual = 4,
}

export enum EMatchStatus {
  /** 已结束 */
  Ms0 = 0,
  /** 延期 推迟时间较长，比赛通常会取消 */
  Ms1 = 1,
  /** 中断 */
  Ms2 = 2,
  /** 取消 */
  Ms3 = 3,
  /** 未开赛 Upcoming */
  Ms4 = 4,
  /** 进行中 */
  Ms5 = 5,
  /** 推迟 推迟时间较短，比赛通常会正常进行 */
  Ms6 = 6,
  /** 废弃 */
  Ms7 = 7,
  /** 暂停 */
  Ms8 = 8,
  /** 滚球不覆盖 */
  Ms9 = 9,
}

